import Cookies from "js-cookie";

const SiteAlert = () => {
  const modal = document.querySelector(".modal");
  const open = document.querySelector(".open-modal");
  const closeButton = document.querySelector(".close-modal");
  const popType = document.querySelector(".pop-up");
  const bothType = document.querySelector(".both");
  const alert = document.querySelector(".alert");

  const toggleModal = () => {
    modal.classList.toggle("show-modal");
  };

  function closeModal(e) {
    if (e.target === modal) {
      toggleModal();
    }
  }

  if (popType) {
    const timestamp = modal.getAttribute("data-timestamp");
    const endTime = modal.getAttribute("data-expires");

    // Set default expiry
    let expiry = 365;

    // If we have an expiry timestamp then set our cookie expiry to this
    if (endTime) {
      expiry = new Date(endTime);
    }

    setTimeout(() => {
      modal.classList.add("show-modal");
    }, 3500);

    window.addEventListener("click", closeModal);
    closeButton.addEventListener("click", () => {
      modal.classList.remove("show-modal");
      alert.classList.add("alert--disable");
      Cookies.set("ALERT_CLOSED", timestamp, { expires: expiry });
    });

    // Hide the alert by default if we have our closed cookie
    if (
      Cookies.get("ALERT_CLOSED") !== "undefined" &&
      Cookies.get("ALERT_CLOSED") !== timestamp
    ) {
      alert.classList.remove("alert--disable");
    }
  }

  if (bothType) {
    open.addEventListener("click", toggleModal);
    closeButton.addEventListener("click", toggleModal);
    window.addEventListener("click", closeModal);
  }
};

export default SiteAlert;
